import { Routes } from '@angular/router';

import { CcdlErrorPageComponent } from '@cpm-pr1618001/ng-design-lib';

import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { authGuardFn } from './app-auth.guard';
import { AboutUsContainerComponent } from './landing-page/about-us/about-us.container.component';
import { ActivatingAccountComponent } from './landing-page/activating-account/activating-account.component';
import { HomeContainer } from './landing-page/home/home.container';
import { LandingPageContainerComponent } from './landing-page/landing-page.container.component';
import { ReactivateAccountEntryComponent } from './landing-page/reactivate-account/reactivate-account-entry.component';
import { LegalContainerComponent } from './legal/legal.container.component';
import { PrivacyAndPolicyComponent } from './legal/privacy-and-policy/privacy-and-policy.component';
import { TermsOfUseComponent } from './legal/terms-of-use/terms-of-use.component';
import { SupportEffects } from './support/store/effects/support.effects';
import { supportFeature } from './support/store/feature/support.feature';

export const routes: Routes = [
  {
    path: 'LandingPage',
    component: LandingPageContainerComponent,
    canActivate: [authGuardFn],
    children: [
      { path: 'Home', component: HomeContainer },
      { path: 'AboutUs', component: AboutUsContainerComponent },
      {
        path: '',
        redirectTo: 'Home',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'legal',
    component: LegalContainerComponent,
    children: [
      { path: 'privacy-policy', component: PrivacyAndPolicyComponent },
      { path: 'terms-of-use', component: TermsOfUseComponent },
    ],
  },
  {
    path: 'support',
    loadChildren: () =>
      import('./support/SUPPORT_ROUTES').then((r) => r.SUPPORT_ROUTES),
    providers: [provideState(supportFeature), provideEffects([SupportEffects])],
  },
  {
    path: 'error-page',
    component: CcdlErrorPageComponent,
  },
  {
    path: 'reactivate-account',
    component: ReactivateAccountEntryComponent,
  },
  {
    path: 'activating-account',
    component: ActivatingAccountComponent,
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'LandingPage',
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'LandingPage',
  },
];
